import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { PlatformHelper } from '@sport1/react-elements'
import SetCompetitor from '../HelperClass/SetCompetitor'
import LabelFont from '../../../Theme/Fonts/Label'
import { CompetitorProps } from '../../Match/MatchTypes'

export type SetRowTemplateProps = {
    homeCompetitor: CompetitorProps
    awayCompetitor: CompetitorProps
    hideImage?: boolean
    onPressMatch?: () => void
    prefix?: ReactElement
    winner?: 'HOME' | 'DRAW' | 'AWAY'
    additionalField?: string
    additionalFieldOffset?: number
    paddingTop?: number | string | number[] | string[]
    borderRadius?: number
    noExpand?: boolean
}

const SetRowTemplate: FunctionComponent<SetRowTemplateProps> = ({
    children,
    onPressMatch,
    prefix,
    homeCompetitor,
    hideImage,
    awayCompetitor,
    winner,
    additionalField,
    additionalFieldOffset,
    paddingTop = 3,
    borderRadius,
    noExpand,
}) => {
    return (
        <Grid
            noExpand={noExpand !== undefined ? noExpand : !PlatformHelper.isNative}
            paddingTop={paddingTop}
            paddingBottom={3}
            backgroundColor="pearl"
            borderRadius={borderRadius}
            overflow="hidden"
        >
            <Grid noExpand width="100%">
                <Touchable onPress={onPressMatch}>
                    <Grid noExpand width="100%" horizontal paddingRight={3} spaceBetween>
                        <Grid noExpand width={20} marginLeft={11} centerVertical>
                            {prefix}
                        </Grid>
                        <Grid minWidth={0}>
                            <SetCompetitor
                                name={homeCompetitor.name}
                                imageUrl={homeCompetitor.logoUrl}
                                imageAlt={homeCompetitor.logoAlt}
                                paddingBottom={3}
                                hideImage={hideImage}
                                bold={winner === 'HOME'}
                            />
                            <SetCompetitor
                                name={awayCompetitor.name}
                                imageUrl={awayCompetitor.logoUrl}
                                imageAlt={awayCompetitor.logoAlt}
                                hideImage={hideImage}
                                bold={winner === 'AWAY'}
                            />
                        </Grid>
                        {children}
                    </Grid>
                    {additionalField ? (
                        <Grid paddingTop={2} paddingLeft={additionalFieldOffset}>
                            <LabelFont numberOfLines={1} color="keshi-3" textAlign="center">
                                {additionalField}
                            </LabelFont>
                        </Grid>
                    ) : null}
                </Touchable>
            </Grid>
        </Grid>
    )
}

export default SetRowTemplate
